import React from 'react';
import { Route } from 'react-router-dom';
import { NotFoundPage } from 'sarsaparilla';

import ProtectedRoute from './ProtectedRoute';
import routesArray from './routesArray';

import LandingPage from '../src/containers/LandingPage';
import AccessAgreementPage from '../src//components/AccessAgreementPage';
import LoginPage from '../src/containers/LoginPage';
import SearchPage from '../src/containers/SearchPage';
import ChangelogPage from '../src/containers/ChangelogPage';
import ProfilePage from '../src/containers/ProfilePage/ProfilePage';
import DocumentationPage from '../src/containers/DocumentationPage';
import DownloadPage from '../src/containers/DownloadPage';
import UserAdminPage from '../src/containers/UserAdminPage';
import StewardEntryPage from '../src/containers/StewardEntryPage';
import StewardSearchPage from '../src/containers/StewardSearchPage';
import StewardAssetNewPage from '../src/containers/StewardAssetNewPage';
import StewardAssetDisplayPage from '../src/containers/StewardAssetDisplayPage';
import StewardAssetEditPage from '../src/containers/StewardAssetEditPage';

const Components = {
    LandingPage,
    AccessAgreementPage,
    LoginPage,
    SearchPage,
    ChangelogPage,
    ProfilePage,
    DocumentationPage,
    DownloadPage,
    UserAdminPage,
    StewardEntryPage,
    StewardAssetNewPage,
    StewardAssetDisplayPage,
    StewardAssetEditPage,
    StewardSearchPage
};

export default function makeSwitchRoutes() {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];

        if (route.requiresAuth) {
            return (
                <ProtectedRoute
                    key={route.path}
                    path={route.path}
                    component={Component}
                    exact={route.exact || false}
                    requiresAdminAccess={route.requiresAdminAccess}
                    requiresWriteAccess={route.requiresWriteAccess} />
            );
        }
        return (
            <Route
                key={route.path}
                path={route.path}
                component={Component}
                exact={route.exact || false} />
        );
    });

    routeComponents.push(
        <Route path="*" key="notFound" component={NotFoundPage} />
    );

    return routeComponents;
}